// extracted by mini-css-extract-plugin
export default {"container":"document_form_text_container__3wD5k","input":"document_form_text_input__Rd+8+","tooltip":"document_form_text_tooltip__zRjIy"};